export default "./img/img-e252f7.png";